import React, { Component } from 'react';
import PublisherModal from './PublisherModal';
import PublisherLists from './PublisherLists'; 
import M from 'materialize-css/dist/js/materialize.min.js';
import 'materialize-css/dist/css/materialize.min.css';
import CirclePreloader from '../layouts/CirclePreloader';
import '../Css/Style.css';
import {getData} from '../Api/Config'
import DeleteModal from '../layouts/DeleteModal';
import {deleteData} from '../Api/Config'

export default class publisherLists extends Component {
  state = {
    publishers:[],
    isloader:false
  }
    componentDidMount(){
      var elems = document.querySelectorAll('.modal');
      M.Modal.init(elems, {});
      this.getAllPublishers();
      }

  getAllPublishers =()=>{
    this.setState({isloader:true});
      getData('publishers').then(res=>{
           this.setState({publishers:res.publishers})
          this.setState({isloader:false});
      }).catch(()=>{
          this.setState({isloader:false});
      })

    //   var url = "https://api.nirmallabs.com/api/admin/v1/publishers";
    //   var bearer = "Bearer " + "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJha3NoYXkudmVybWEiLCJleHAiOjE1OTczMDQ5NzcsImlhdCI6MTU5NzIxODU3N30.McIBOToYiqo3KQDF37Y5_YDOz29XStWEN38YKnuHIL3gfiMIRg8-OV5gGkJDd9CXAcvQiY2J6LSkkcF-rEfGPw";
    //   fetch(url, {
    //     method: 'GET',
    //     // withCredentials: true,
    //     // credentials: 'include',
    //     headers: {
    //         'Authorization': bearer,
    //         'Content-Type': 'application/json'
    //     }
    // }).then(res=>res.json()).then(r=>{
    //   console.log(r)
    // }).catch(err=>{
    //   console.log(err)
    // })
  }

  handleDelete=(Id)=>{
    // console.log("asdasd")
    deleteData("publishers",Id).then(res=>{
        this.getAllPublishers();
    }).catch(err=>{
        console.log(err);
    })
  }

    render() {
      let mystyle = this.state.isloader?{
        visibility: 'hidden'
        }:{
          visibility: 'visible'
        }
        return (
            <div>
                 <h5>Publishers</h5>
                <div className="card z-depth-2 hoverable">
                  <div className="card-content">
                    {/* for adding new publisher */}
                    <button  data-target="New publisher" className="btn btn-small blue-grey modal-trigger">New Publisher<i className="material-icons right">add</i></button>
                    {/* pop model form Component */}
                    
                    <PublisherModal Id="New publisher" getAllPublishers={this.getAllPublishers} />
                    {this.state.isloader?<CirclePreloader />:null}
                    
                   {this.state.publishers?(
                     <>
                    <table className="highlight" style={mystyle} >
                    <thead>
                      <tr>
                          <th>ID</th>
                          <th className="tb-w">Name</th>
                          <th colSpan="2">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                    {this.state.publishers && [...this.state.publishers].map((pub)=>{
                     return <PublisherLists publisher={pub} key={pub.id} getAllPublishers={this.getAllPublishers} />
                    })}
                    </tbody>
                    
                    </table>
                    {this.state.publishers && [...this.state.publishers].map((pub)=>{
                     return <DeleteModal key={pub.id+'del'}  id={pub.id+'del'} handleDelete={()=>this.handleDelete(pub.id)}/>
                    })}
                    </>
                    ):(<span style={{marginTop:50}}>No publisher yet....!</span>)}
                 </div>
                </div>
              </div>
        )
    }
}
